const en = {
  // Common
  common: {
    back: '← Back',
    backToLogin: '← Back to Login',
    backToCadastro: '← Back to Registration',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    required: 'required',
    save: 'Save',
    cancel: 'Cancel',
    search: 'Search',
    na: 'N/A',
  },

  // HomePage
  home: {
    subtitle: 'Application Certificate System',
    btnApplicator: 'I\'m an Applicator',
    btnCertificate: 'View Certificate',
  },

  // LoginPage
  login: {
    title: 'Applicator Area',
    subtitle: 'Log in to access the registration system',
    email: 'Email',
    emailPlaceholder: 'Enter your email',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    submit: 'Log In',
    submitting: 'Logging in...',
    forgotPassword: 'Forgot password',
    rememberMe: 'Remember me for 30 days',
    noAccount: 'Don\'t have an account yet?',
    register: 'Register new applicator',
    successMessage: '✅ Login successful!',
    errorMessage: '❌ Login failed. Please try again.',
    methodPassword: 'Email & Password',
    methodCpf: 'CPF + Code',
    cpfLabel: 'CPF',
    cpfPlaceholder: 'Enter your registered CPF',
    sendCode: 'Send Code',
    sendingCode: 'Sending...',
    changeCpf: '← Use another CPF',
    codeLabel: 'Code received by email',
    codePlaceholder: 'Enter the 6-digit code',
    codeHint: 'We sent a code to the email registered with this CPF. Check your spam folder too.',
    verifyCode: 'Log In',
    verifyingCode: 'Verifying...',
    resendCode: 'Resend code',
  },

  // CadastroAplicadorPage
  register: {
    title: 'Applicator Registration',
    subtitle: 'Fill in the details to create a new applicator account',
    fullName: 'Full Name',
    fullNamePlaceholder: 'Enter full name',
    email: 'Email',
    emailPlaceholder: 'Enter email',
    cpfCnpj: 'CPF or CNPJ',
    phone: 'Phone (with area code)',
    phonePlaceholder: '(00) 00000-0000',
    instagram: 'Instagram',
    instagramPlaceholder: 'your.profile',
    password: 'Password',
    passwordPlaceholder: 'Create a password',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Confirm your password',
    showPassword: 'Show',
    hidePassword: 'Hide',
    submit: 'Register Applicator',
    submitting: 'Registering...',
    goToLogin: 'Go to Login',
    successMessage: 'Applicator registered successfully! You can now log in.',
    errorMessage: 'Error registering applicator. Please try again.',
    passwordMismatch: 'Passwords do not match.',
    passwordMinLength: 'Password must be at least 8 characters long.',
    passwordComplexity: 'Password must contain at least one lowercase letter, one uppercase letter, and one number.',
    // Studio section
    studioSection: 'Studio Address',
    studioName: 'Studio Name *',
    studioNamePlaceholder: 'E.g.: Detailing Center Studio',
    studioCep: 'Zip Code *',
    studioCepPlaceholder: '00000-000',
    studioEndereco: 'Street *',
    studioEnderecoPlaceholder: 'Filled by zip code',
    studioNumero: 'Number *',
    studioNumeroPlaceholder: 'No.',
    studioComplemento: 'Complement',
    studioComplementoPlaceholder: 'Suite, Block, etc.',
    studioBairro: 'Neighborhood *',
    studioBairroPlaceholder: 'Filled by zip code',
    studioCidade: 'City *',
    studioCidadePlaceholder: 'Filled by zip code',
    studioEstado: 'State *',
    studioEstadoPlaceholder: 'ST',
    studioCepSearching: 'Searching zip code...',
    studioCepError: 'Zip code not found. Fill in manually.',
  },

  // BuscaCertificadoPage
  certificate: {
    title: 'Check Certificates',
    subtitle: 'Enter your details to view your application certificates',
    cpf: 'CPF',
    cpfPlaceholder: 'Enter your CPF',
    searchBtn: 'Search Certificates',
    searching: 'Searching...',
    notFound: 'No certificates found for the provided data.',
    errorSearch: 'Error searching certificates. Please check the data and try again.',
    found: 'Certificates Found',
    certId: 'Certificate ID:',
    applicationDate: 'Application Date:',
    vehicleData: 'Vehicle Data',
    model: 'Model:',
    color: 'Color:',
    plate: 'Plate:',
    serialNumber: 'Serial Number:',
    applicator: 'Applicator:',
    location: 'Location:',
    vehiclePhoto: 'Vehicle Photo',
    warrantyPerProduct: 'Certificate per Product',
    warranty: 'Certificate:',
    validUntil: 'Valid until:',
    active: 'Active - Remaining',
    warning: 'Warning - Remaining',
    expired: 'Certificate Expired',
    dateUnavailable: 'Date unavailable',
    maintenance: 'Recommended Maintenance',
    maintenanceText: 'We recommend coating maintenance every <strong>6 months</strong> from the application date to maintain protection and vehicle shine.',
    maintenanceUpcoming: 'Maintenance Due Soon!',
    maintenanceNext: 'Next Maintenance',
    maintenanceToday: 'Today or overdue',
    maintenanceTomorrow: 'Tomorrow',
    maintenanceInDays: 'In {{days}} days',
    scheduleWhatsapp: 'Schedule your maintenance',
    whatsappMessage: 'Hello, I need to schedule a maintenance/evaluation for the ceramic coating on my vehicle',
    contactApplicator: 'Applicator: <strong>{{name}}</strong> — Contact to schedule maintenance.',
    allExpired: 'CERTIFICATES EXPIRED',
    attentionBadge: 'APPLICATION CERTIFICATE - ATTENTION',
    validBadge: 'VALID APPLICATION CERTIFICATE',
  },

  // Studios
  studios: {
    title: 'My Studios',
    subtitle: 'Manage your studio addresses',
    addStudio: 'Add Studio',
    editStudio: 'Edit Studio',
    deleteStudio: 'Delete',
    deleteConfirm: 'Are you sure you want to delete this studio?',
    noStudios: 'No studios registered.',
    saveSuccess: 'Studio saved successfully!',
    deleteSuccess: 'Studio removed successfully!',
    errorSave: 'Error saving studio.',
    errorDelete: 'Error removing studio.',
    errorLoad: 'Error loading studios.',
    selectStudio: 'Select studio *',
    selectPlaceholder: 'Select a studio...',
    noStudiosRegistered: 'No studios registered. Register a studio in "My Records" first.',
  },

  // MeusCadastrosPage
  myCerts: {
    title: 'My Registrations',
    subtitle: 'Vehicles registered by {{name}}',
    subtitleDefault: 'Vehicles registered by you',
    totalRegistrations: 'Total Registrations',
    searchPlaceholder: 'Search by name, plate, model or CPF...',
    noResults: 'No results found for the search.',
    empty: 'You don\'t have any registered vehicles yet.',
    client: 'Client',
    cpf: 'CPF',
    color: 'Color',
    products: 'Products',
    serial: 'Serial',
    local: 'Location',
    cert: 'Certificate',
    tapToView: 'Tap to view full certificate',
    loadingCerts: 'Loading registrations...',
    errorLoad: 'Error loading registrations. Please try again.',
    retry: 'Try Again',
  },

  // CadastroPage
  cadastro: {
    title: 'Application Registration',
    subtitle: 'Fill in all client and application details',
    applicator: 'Applicator:',
    loading: 'Loading...',
    // Client section
    clientSection: 'Client Data',
    cpfLabel: 'CPF * (enter and click search to check for existing client)',
    cpfPlaceholder: 'Enter client CPF',
    searchCpf: 'Search CPF',
    searchingCpf: 'Searching...',
    clientFound: 'Client found! {{certs}} certificate(s) and {{vehicles}} vehicle(s) registered. Personal data filled. Fill in the new vehicle data.',
    clientExistsBanner: 'Client already registered!',
    clientExistsBannerText: 'Personal data filled automatically. {{count}} vehicle(s) registered.',
    newClient: 'New Client',
    fullName: 'Full Name *',
    phone: 'Phone *',
    email: 'Email',
    birthDate: 'Date of Birth',
    state: 'State *',
    stateSelect: 'Select...',
    address: 'Full Address',
    cep: 'ZIP Code',
    cepPlaceholder: '00000-000',
    cepError: 'ZIP code not found. Please fill in the address manually.',
    numero: 'Number',
    numeroPlaceholder: 'No.',
    logradouro: 'Street',
    logradouroPlaceholder: 'Auto-filled from ZIP code',
    complemento: 'Complement',
    complementoPlaceholder: 'Apt, block, etc. (optional)',
    bairro: 'Neighborhood',
    cidade: 'City',
    // Existing vehicles
    registeredVehicles: 'Registered Vehicles',
    registeredVehiclesHint: 'Vehicles already registered for this client. Select one for a new application or register a new one below.',
    selectVehicle: 'Select this vehicle',
    vehicleDataFilled: 'Vehicle data filled. Update the application details.',
    colorLabel: 'Color:',
    productsLabel: 'Products:',
    applicationLabel: 'Application:',
    // Vehicle section
    vehicleSection: 'Vehicle Data',
    newVehicleSection: 'New Vehicle / New Application',
    plate: 'Plate *',
    platePlaceholder: 'E.g.: ABC1234',
    searchPlaca: '🔍 Search',
    searchingPlaca: 'Searching...',
    placaHintSearching: '🔄 Searching vehicle...',
    placaHint: 'Auto-search when full plate is entered',
    vehicleModel: 'Car Model *',
    yearModel: 'Year/Model',
    yearPlaceholder: 'Filled automatically',
    color: 'Color *',
    colorPlaceholder: 'E.g.: Silver, Black, White',
    vehicleFound: '✅ Vehicle found and data filled automatically!',
    vehicleError: 'Error searching vehicle. Please try again.',
    // Application section
    applicationSection: '🔧 Application Details',
    productsApplied: 'Products Applied *',
    noProducts: 'No product selected',
    searchProducts: 'Type to search products...',
    productsWarning: 'Select at least one product',
    serialNumbers: 'Serial Numbers * (one per product)',
    serialPlaceholder: 'Serial number for {{product}}',
    applicationDate: 'Application Date *',
    applicationLocation: 'Application Location *',
    locationPlaceholder: 'E.g.: São Paulo - SP',
    // Photo section
    photoSection: '📸 Vehicle Photo',
    photoUpload: 'Click to add vehicle photo',
    photoFormats: 'Formats: JPG, PNG, GIF (max 5MB)',
    removePhoto: 'Remove photo',
    fileTooLarge: '❌ File must be 5MB or less',
    fileTypeError: '❌ Only image files are allowed',
    // Submit
    submit: 'Register Application',
    submitting: 'Registering...',
    successMessage: '✅ Registration successful! Certificate ID: {{id}}',
    errorMessage: '❌ Error registering. Please try again.',
    selectOneProduct: '❌ Select at least one applied product',
    // Scanner
    scannerTitle: 'Scan Barcode',
    scannerHint: 'Point the camera at the product barcode',
    scannerError: 'Could not access camera. Check browser permissions.',
    scannerTooltipTitle: '📷 Barcode Scanner',
    scannerTooltipPurpose: 'To automatically read product serial numbers using your phone camera.',
    scannerTooltipHow: 'How to use:',
    scannerStep1: 'Click the camera icon',
    scannerStep2: 'Allow camera access when prompted',
    scannerStep3: 'Point the camera at the product barcode',
    scannerStep4: 'Wait for automatic recognition',
    scannerStep5: 'The number will be filled automatically',
    scannerTip: 'Make sure the barcode is well-lit and without reflections.',
    // Nav
    myCerts: '📋 My Registrations',
    // Tutorial
    tutorialButton: '❓ Tutorial',
    tutorialTitle: 'How to use the app',
    tutorialStep1: 'Search for the client by CPF. If they already exist, their data will be filled in automatically.',
    tutorialStep2: 'Fill in the client\'s personal details (name, phone, email, address).',
    tutorialStep3: 'Enter the vehicle plate to automatically look up the model and color, or fill it in manually.',
    tutorialStep4: 'Select the applied products and enter the serial number for each one (use the barcode scanner if you prefer).',
    tutorialStep5: 'Choose the application date, the studio where the service was performed, and add a photo of the vehicle.',
    tutorialStep6: 'Click "Register Application" to generate the certificate.',
    tutorialHint: 'You can access all previously registered certificates in the "My Registrations" tab.',
  },

  // EsqueciSenhaPage
  forgotPassword: {
    title: 'Recover Password',
    subtitle: 'Enter your email to receive recovery instructions',
    email: 'Email',
    emailPlaceholder: 'Enter your registered email',
    submit: 'Send Instructions',
    submitting: 'Sending...',
    backToLogin: 'Back to Login',
    howItWorks: 'How does it work?',
    step1: '1. Enter your registered email',
    step2: '2. If the email is registered, you will receive instructions',
    step3: '3. Follow the instructions in the email to reset your password',
    notReceived: 'Didn\'t receive the email?',
    checkSpam: '• Check your spam folder',
    waitMinutes: '• Wait a few minutes',
    checkEmail: '• Make sure the email is correct',
    errorMessage: 'Error processing request. Please try again.',
  },

  // RedefinirSenhaPage
  resetPassword: {
    title: 'Reset Password',
    verifying: 'Verifying link...',
    validatingLink: 'Validating your reset link...',
    invalidTitle: 'Invalid Link',
    invalidSubtitle: 'This link is no longer valid',
    requestNewLink: 'Request New Link',
    backToLogin: 'Back to Login',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'Enter your new password',
    confirmPassword: 'Confirm New Password',
    confirmPasswordPlaceholder: 'Confirm your new password',
    showPasswords: 'Show passwords',
    submit: 'Reset Password',
    submitting: 'Resetting...',
    goToLogin: 'Go to Login',
    successSubtitle: 'Password reset successfully!',
    enterNew: 'Enter your new password',
    requirements: 'Password must contain:',
    minChars: 'At least 8 characters',
    lowercase: 'One lowercase letter',
    uppercase: 'One uppercase letter',
    number: 'One number',
    passwordMismatch: 'Passwords do not match.',
    passwordMinLength: 'Password must be at least 8 characters long.',
    passwordComplexity: 'Password must contain at least one lowercase letter, one uppercase letter, and one number.',
    errorMessage: 'Error resetting password. Please try again.',
  },

  // Footer
  footer: {
    rights: '© 2024 IGL Coatings Brasil. All rights reserved.',
    authenticity: 'IGL Coatings Certificate of Authenticity',
  },

  // Warranty duration
  warranty: {
    year: '1 year',
    years: '{{n}} years',
    months: '{{n}} months',
  },
};

export default en;
